<div class="step-form">
    <ng-container [ngSwitch]="currentStep">

        <!-- NEW STEP 1: WELCOME -->
        <ng-template [ngSwitchCase]="1">

            <div class="step-form">
                <div class="form-card text-center p-5" style="border: none; background: transparent; box-shadow: none;">
                    <div class="mb-5 welldone-header">
                        <img src="assets/logo-icon.svg" alt="Welldone Logo" class="welldone-logo">
                        <h1 class="welldone-title">
                            WELL DONE
                        </h1>
                    </div>

                    <h1 class="mb-4" style="font-weight: 800; font-size: 1.5rem; color: #5E6278;">
                        Benvenuto nell'area di onboarding
                    </h1>

                    <p class="mb-5" style="font-size: 1.5rem; font-weight: 600; color: #5E6278;">
                        Iniziamo la compilazione<br>della richiesta
                    </p>

                    <button class="btn-procedi" (click)="nextStep()" style="min-width: 200px;">
                        Procedi
                    </button>
                </div>
            </div>
        </ng-template>

        <!-- STEP 2 (ex 1) -->
        <ng-template [ngSwitchCase]="2">
            <div class="step-text">
                <h2 class="step-title">
                    Seleziona il <span class="gradient-text">Ruolo</span>
                </h2>

                <span class="step-subtitle">
            <i class="bi bi-person-badge"></i>
            Scegli la tipologia che meglio descrive la tua attività.
        </span>
            </div>
            <div class="step-form">
                <div class="row g-4">
                    <div *ngFor="let r of roles; let i = index"
                         [class]="i === 2 ? 'col-12' : 'col-md-6'">
                        <div class="card staff-type-card"
                             [class.selected]="newStaff.role === r.value"
                             (click)="selectRole(r.value)">
                            <div class="card-body">
                                <div class="card-icon">
                                    <i [class]="r.icon"></i>
                                </div>
                                <div class="card-text">
                                    <h5 class="card-title">
                                        {{ r.label }}
                                    </h5>
                                    <p class="card-description">
                                        {{ r.description }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <button class="btn-procedi"
                        [disabled]="!newStaff.role"
                        (click)="nextStep()">
                    Procedi
                </button>
            </div>
        </ng-template>
        <!-- STEP 3 (ex 2) -->
        <ng-template [ngSwitchCase]="3">

            <div class="step-text">
                <h2 class="step-title">
                    Dati <span class="gradient-text">Personali</span>
                </h2>
            </div>

            <form class="row g-3" #personalInfoForm="ngForm">
                <div class="col-md-6">
                    <label for="staff-firstname" class="form-label required">Nome</label>
                    <input
                            type="text"
                            class="form-control"
                            id="staff-firstname"
                            [(ngModel)]="newStaff.firstName"
                            name="firstName"
                            required
                            #firstName="ngModel"
                            (ngModelChange)="persistForm()"
                            [class.is-invalid]="firstName.invalid && (firstName.dirty || firstName.touched)">
                    <div class="invalid-feedback">Il nome è obbligatorio.</div>
                </div>
                <div class="col-md-6">
                    <label for="staff-lastname" class="form-label required">Cognome</label>
                    <input
                            type="text"
                            class="form-control"
                            id="staff-lastname"
                            [(ngModel)]="newStaff.lastName"
                            name="lastName"
                            required
                            #lastName="ngModel"
                            (ngModelChange)="persistForm()"
                            [class.is-invalid]="lastName.invalid && (lastName.dirty || lastName.touched)">
                    <div class="invalid-feedback">Il cognome è obbligatorio.</div>
                </div>
                <div class="col-md-6">
                    <label for="staff-email" class="form-label required">Email</label>
                    <input
                            type="email"
                            class="form-control"
                            id="staff-email"
                            placeholder="email@esempio.com"
                            [(ngModel)]="newStaff.email"
                            name="email"
                            required
                            #email="ngModel"
                            email
                            (ngModelChange)="persistForm()"
                            [class.is-invalid]="email.invalid && (email.dirty || email.touched)">
                    <div class="invalid-feedback">
                        <span *ngIf="email.errors?.['required']">L'email è obbligatoria.</span>
                        <span *ngIf="email.errors?.['email']">Inserisci un indirizzo email valido.</span>
                    </div>

                </div>
                <div class="col-md-6">
                    <label for="staff-phone" class="form-label required">Telefono</label>
                    <input
                            type="text"
                            class="form-control"
                            id="staff-phone"
                            placeholder="+39 000 000 0000"
                            [(ngModel)]="newStaff.phone"
                            name="phone"
                            required
                            #phone="ngModel"
                            pattern="[0-9+][0-9]*"
                            (ngModelChange)="persistForm()"
                            [class.is-invalid]="phone.invalid && (phone.dirty || phone.touched)">
                    <div class="invalid-feedback">
                        <span *ngIf="phone.errors?.['required']">Il telefono è obbligatorio.</span>
                        <span *ngIf="phone.errors?.['pattern']">Inserisci un numero di telefono valido (solo numeri).</span>
                    </div>
                </div>
            </form>

            <div class="buttons">
                <div class="btn-back"
                     (click)="previousStep()">
                    Indietro
                </div>
                <button class="btn-procedi"
                        [disabled]="!isPersonalInfoValid()"
                        (click)="nextStep()">
                    Procedi
                </button>
            </div>
        </ng-template>

        <!-- STEP 5 (ex 4) DOCUMENTI -->
        <ng-template [ngSwitchCase]="4">
            <h2 class="step-title">Documenti</h2>

            <div class="row g-4">

                <!-- CARTA IDENTITA -->
                <div class="col-12">
                    <div class="card shadow-sm border-0 rounded-4 p-4">

                        <h5 class="mb-3">Carta d'identità</h5>

                        <div class="row g-3">

                            <!-- Fronte -->
                            <div class="col-md-6">
                                <label class="form-label required">Fronte</label>

                                <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                                     [class.border-danger]="!newStaff.id_front_file"
                                     [class.border-success]="newStaff.id_front_file"
                                     [class.border-slate-300]="newStaff.id_front_file"
                                     (click)="idFrontInput.click()"
                                     (dragover)="$event.preventDefault()"
                                     (drop)="onDocumentDrop($event, 'id_front_file')">
                                    <div class="fw-semibold mb-1">
                                        Clicca o trascina qui il documento
                                    </div>
                                    <div class="text-muted small" *ngIf="!newStaff.id_front_file">
                                        Formati supportati: JPG, PNG, PDF
                                    </div>
                                    <div class="text-success small fw-semibold" *ngIf="newStaff.id_front_file">
                                        ✅ {{ newStaff.id_front_file.name }}
                                    </div>
                                </div>
                                <input type="file" #idFrontInput class="d-none" accept="image/*,application/pdf"
                                       (change)="chooseDocument($event, 'id_front_file')"/>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label required">Retro</label>
                                <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                                     [class.border-danger]="!newStaff.id_back_file"
                                     [class.border-success]="newStaff.id_back_file"
                                     [class.border-slate-300]="newStaff.id_back_file"
                                     (click)="idBackInput.click()"
                                     (dragover)="$event.preventDefault()"
                                     (drop)="onDocumentDrop($event, 'id_back_file')">
                                    <div class="fw-semibold mb-1">
                                        Clicca o trascina qui il documento
                                    </div>
                                    <div class="text-muted small" *ngIf="!newStaff.id_back_file">
                                        Formati supportati: JPG, PNG, PDF
                                    </div>
                                    <div class="text-success small fw-semibold" *ngIf="newStaff.id_back_file">
                                        ✅ {{ newStaff.id_back_file.name }}
                                    </div>
                                </div>
                                <input type="file" #idBackInput class="d-none" accept="image/*,application/pdf"
                                       (change)="chooseDocument($event, 'id_back_file')"/>
                            </div>
                            <div class="col-12">
                                <div class="d-flex align-items-center gap-3">
                                    <label class="form-label mb-0 text-nowrap">
                                        Data scadenza documento
                                    </label>
                                    <input
                                            type="date"
                                            class="form-control"
                                            [(ngModel)]="newStaff.id_expiry"
                                            name="id_expiry"
                                            required
                                            (ngModelChange)="persistForm()">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card shadow-sm border-0 rounded-4 p-4">
                        <h5 class="mb-3">Codice Fiscale</h5>
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label required">Fronte</label>
                                <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                                     [class.border-danger]="!newStaff.cf_front_file"
                                     [class.border-success]="newStaff.cf_front_file"
                                     [class.border-slate-300]="newStaff.cf_front_file"
                                     (click)="cfFrontInput.click()"
                                     (dragover)="$event.preventDefault()"
                                     (drop)="onDocumentDrop($event, 'cf_front_file')">
                                    <div class="fw-semibold mb-1">
                                        Clicca o trascina qui il documento
                                    </div>
                                    <div class="text-muted small" *ngIf="!newStaff.cf_front_file">
                                        Formati supportati: JPG, PNG, PDF
                                    </div>
                                    <div class="text-success small fw-semibold" *ngIf="newStaff.cf_front_file">
                                        ✅ {{ newStaff.cf_front_file.name }}
                                    </div>
                                </div>
                                <input type="file" #cfFrontInput class="d-none" accept="image/*,application/pdf"
                                       (change)="chooseDocument($event, 'cf_front_file')"/>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label required">Retro</label>
                                <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                                     [class.border-danger]="!newStaff.cf_back_file"
                                     [class.border-success]="newStaff.cf_back_file"
                                     [class.border-slate-300]="newStaff.cf_back_file"
                                     (click)="cfBackInput.click()"
                                     (dragover)="$event.preventDefault()"
                                     (drop)="onDocumentDrop($event, 'cf_back_file')">
                                    <div class="fw-semibold mb-1">
                                        Clicca o trascina qui il documento
                                    </div>
                                    <div class="text-muted small" *ngIf="!newStaff.cf_back_file">
                                        Formati supportati: JPG, PNG, PDF
                                    </div>
                                    <div class="text-success small fw-semibold" *ngIf="newStaff.cf_back_file">
                                        ✅ {{ newStaff.cf_back_file.name }}
                                    </div>
                                </div>
                                <input type="file" #cfBackInput class="d-none" accept="image/*,application/pdf"
                                       (change)="chooseDocument($event, 'cf_back_file')"/>
                            </div>


                            <div class="col-12">
                                <div class="d-flex align-items-center gap-3">
                                    <label class="form-label mb-0 text-nowrap">
                                        Data scadenza documento
                                    </label>
                                    <input
                                            type="date"
                                            class="form-control"
                                            [(ngModel)]="newStaff.cf_expiry"
                                            name="cf_expiry"
                                            required
                                            (ngModelChange)="persistForm()">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- PATENTE -->
                <div class="col-12" *ngIf="needsLicense()">
                    <div class="card shadow-sm border-0 rounded-4 p-4">
                        <h5 class="mb-3">Patente</h5>
                        <label class="form-label required">Patente</label>
                        <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                             [class.border-danger]="!newStaff.license_file"
                             [class.border-success]="newStaff.license_file"
                             [class.border-slate-300]="newStaff.license_file"
                             (click)="licenseInput.click()"
                             (dragover)="$event.preventDefault()"
                             (drop)="onDocumentDrop($event, 'license_file')">
                            <div class="fw-semibold mb-1">
                                Clicca o trascina qui il documento
                            </div>
                            <div class="text-muted small" *ngIf="!newStaff.license_file">
                                Formati supportati: JPG, PNG, PDF
                            </div>
                            <div class="text-success small fw-semibold" *ngIf="newStaff.license_file">
                                ✅ {{ newStaff.license_file.name }}
                            </div>
                        </div>
                        <input type="file" #licenseInput class="d-none" accept="image/*,application/pdf"
                               (change)="chooseDocument($event, 'license_file')"/>


                        <div class="col-12 mt-3">
                            <div class="d-flex align-items-center gap-3">
                                <label class="form-label mb-0 text-nowrap">
                                    Data scadenza patente
                                </label>
                                <input
                                        type="date"
                                        class="form-control"
                                        [(ngModel)]="newStaff.license_expiry"
                                        name="license_expiry"
                                        required
                                        (ngModelChange)="persistForm()">
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="buttons mt-4">
                <div class="btn-back" (click)="previousStep()">
                    Indietro
                </div>

                <button class="btn-procedi"
                        [disabled]="!isDocumentsValid() || isProcessing"
                        (click)="nextStep()">
                    Procedi
                </button>
            </div>
        </ng-template>

        <!-- STEP 6 (ex 5) CREDENZIALI -->
        <ng-template [ngSwitchCase]="5">

            <h2 class="step-title">Credenziali</h2>

            <form class="row g-3">

                <div class="col-md-12">
                    <label class="form-label required">Password</label>
                    <div class="input-group">
                        <input [type]="showPassword ? 'text' : 'password'" class="form-control"
                               [(ngModel)]="newStaff.password" name="password" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="persistForm()">
                        <button class="btn btn-outline-secondary" (click)="showPassword=!showPassword" type="button">
                            <i class="fa fa-eye"></i>
                        </button>
                    </div>
                    <div *ngIf="newStaff.password && !isPasswordComplexEnough()"
                         class="text-danger mt-1" style="font-size: 0.875rem;">
                        La password deve contenere almeno 8 caratteri, una lettera maiuscola, una minuscola, un
                        numero e un carattere speciale.
                    </div>
                </div>

                <div class="col-md-12">
                    <label class="form-label required">Conferma Password</label>
                    <div class="input-group">
                        <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                               [(ngModel)]="newStaff.confirmPassword" name="confirmPassword"
                               [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="persistForm()">
                        <button class="btn btn-outline-secondary" (click)="showConfirmPassword=!showConfirmPassword"
                                type="button">
                            <i class="fa fa-eye"></i>
                        </button>
                    </div>
                    <div *ngIf="newStaff.confirmPassword && newStaff.password !== newStaff.confirmPassword"
                         class="invalid-feedback d-block mt-1">
                        Le password non corrispondono.
                    </div>
                </div>

            </form>

            <div class="buttons">

                <div class="btn-back" (click)="previousStep()">Indietro</div>

                <button class="btn-procedi" [disabled]="!isPasswordValid()" (click)="nextStep()">Procedi</button>

            </div>

        </ng-template>


        <!-- STEP 7 (ex 6) TERMS -->
        <ng-template [ngSwitchCase]="6">

            <div class="step-text" style="padding-top: 4rem; margin-bottom: 1rem !important;">
                <h2 class="step-title">
                    Termini e condizioni del <span class="gradient-text">servizio</span>
                </h2>
                <span class="step-subtitle">Per poter accedere ai nostri servizi devi leggere e accettare i termini e condizioni forniti.</span>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="termsandconditions"
                           [(ngModel)]="termsAndConditionAccepted">
                    <label class="form-check-label" for="termsandconditions">
                        * Dichiaro di aver letto, compreso e di accettare i <a href="assets/pdf/terms_utente.pdf"
                                                                               target="_blank">Termini e condizioni del
                        servizio</a>
                    </label>
                </div>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="privacy"
                           [(ngModel)]="privacyAccepted">
                    <label class="form-check-label" for="privacy">
                        * Dichiaro di aver preso visione dell’informativa <a href="assets/pdf/privacy.pdf"
                                                                             target="_blank">privacy</a>
                    </label>
                </div>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="company-rules"
                           [(ngModel)]="companyRulesAccepted">
                    <label class="form-check-label" for="company-rules">
                        * Dichiaro di aver preso visione del <a [href]="companyRules">regolamento societario</a>
                    </label>
                </div>
            </div>
            <div class="buttons">
                <div
                        class="btn-back"
                        (click)="previousStep()">
                    Indietro
                </div>
                <button
                        class="btn-procedi"
                        #nextButtonTerms
                        (click)="nextStep()">
                    Procedi
                </button>
            </div>
        </ng-template>

        <ng-template [ngSwitchCase]="7">
            <div class="step-text" style="padding-top: 4rem; margin-bottom: 1rem !important;">
                <h2 class="step-title">Conferma operazione</h2>
                <span class="step-subtitle">Per procedere e confermare l'attivazione inserisci il codice OTP che ti abbiamo inviato via email.</span>
            </div>
            <div class="form-check" style="padding-left: 0;">
                <label class="form-check-label required" for="company-OTP">
                    Codice OTP
                </label>
                <input type="text" class="form-control" id="company-OTP"
                       [(ngModel)]="OTPCode"
                       maxlength="6">
            </div>
            <div class="continue-step-btn buttons">
                <div class="btn-back" (click)="previousStep()">
                    Indietro
                </div>
                <button class="btn btn-procedi"
                        [disabled]="!isOtpValid()"
                        (click)="checkOTP(OTPCode, newStaff.email)">
                    Verifica e Procedi
                </button>
            </div>
        </ng-template>
        <ng-template [ngSwitchCase]="8">
            <div class="step-text text-center">
                <div class="mb-4">
                    <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
                </div>
                <h2 class="step-title">Registrazione completata!</h2>
                <span class="step-subtitle">Congratulazioni, la tua richiesta è stata presa in carico correttamente.</span>
            </div>
            <div class="notice-card mt-4">
                <div class="notice-icon">
                    <i class="bi bi-info-circle-fill text-warning fs-2"></i>
                </div>
                <div class="notice-text">
                    <h4 class="notice-title">In attesa di approvazione!</h4>
                    <div class="notice-description">
                        L'amministrazione della società sportiva ha preso in carico la sua richiesta di registrazione.
                    </div>
                </div>
            </div>
            <div class="buttons d-flex justify-content-center mt-5">
                <div class="btn-procedi" (click)="backToLogin()">Torna al login</div>
            </div>
        </ng-template>
    </ng-container>
</div>
